import { render } from "./CookiesDropInput.vue?vue&type=template&id=140445fe&scoped=true"
import script from "./CookiesDropInput.vue?vue&type=script&lang=js"
export * from "./CookiesDropInput.vue?vue&type=script&lang=js"

import "./CookiesDropInput.vue?vue&type=style&index=0&id=140445fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140445fe"]])

export default __exports__